import { c as _c } from "react/compiler-runtime";
import React from 'react';
import IconPremiumDelivery from 'components/icons/iconPremiumDelivery';
const PremiumDeliveryIcon = t0 => {
  const $ = _c(2);
  const {
    color
  } = t0;
  let t1;
  if ($[0] !== color) {
    t1 = <IconPremiumDelivery width="34" height="34" color={color} />;
    $[0] = color;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default PremiumDeliveryIcon;